// extracted by mini-css-extract-plugin
export var aiStarIcon = "_a1-4";
export var closeButton = "_a1-6";
export var dismissButton = "_a1-3";
export var editImageWithAiContainer = "_a1-8";
export var imageUploadWrapper = "_a1-7";
export var misspelledWord = "_a1-5";
export var spellCheckContainer = "_a1-2";
export var spin = "_a1-1";
export var spinning = "_a1-0";